module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"board":"board |  boards","summary_title":{"all":"All Boards","inProgress":"In progress","done":"Done","overdue":"Overdue"}},"th":{"board":"บอร์ด","summary_title":{"all":"บอร์ดทั้งหมด","inProgress":"งานที่กำลังดำเนินการ","done":"งานที่เสร็จทั้งหมด","overdue":"งานที่เกินกำหนด"}}}')
  delete Component.options._Ctor
}
